module.exports = {
  1: { id: 1, name: 'Quality', enabled: true },
  2: { id: 2, name: 'Billing Progress', enabled: false },
  3: { id: 3, name: 'Billing by Exam Type', enabled: false },
  4: { id: 4, name: 'Training Progress', enabled: true },
  5: { id: 5, name: 'Progress by Exam Type', enabled: true },
  6: { id: 6, name: 'Efficiency', enabled: true },
};
